// Line-level parsers for HEC-RAS format (Tier 2)
// Use atomic parsers + logic for single lines

import { chunkStringToNumbers, chunkStringToNumbersOrNull, numbersToCoordinates } from "./atomic"

// ============================================================================
// LINE-LEVEL PARSERS
// ============================================================================

/**
 * Parse a line of fixed-width coordinate data (16 characters per number)
 * @param line Line containing coordinate data
 * @returns Array of {x, y} coordinate objects
 */
export function parseLineToCoordinates(line: string): { x: number; y: number }[] {
  return numbersToCoordinates(chunkStringToNumbers(line, 16))
}

/**
 * Parse a line of fixed-width station pairs (8 characters per number)
 * @param line Line containing station pair data
 * @returns Array of {upstreamStation, downstreamStation} objects
 */
export function parseLineStationPairs(line: string): { upstreamStation: number; downstreamStation: number }[] {
  const nums = chunkStringToNumbers(line, 8)
  const stationPairs: { upstreamStation: number; downstreamStation: number }[] = []

  for (let i = 0; i < nums.length; i += 2) {
    if (i + 1 < nums.length) {
      stationPairs.push({
        upstreamStation: nums[i],
        downstreamStation: nums[i + 1],
      })
    }
  }

  return stationPairs
}

/**
 * Parse a line of fixed-width station pairs with null support (8 characters per number)
 * @param line Line containing station pair data (may contain empty/null values)
 * @returns Array of {upstreamStation, downstreamStation} objects with possible null values
 */
export function parseLineStationPairsWithNulls(
  line: string,
): { upstreamStation: number | null; downstreamStation: number | null }[] {
  const nums = chunkStringToNumbersOrNull(line, 8)
  const stationPairs: { upstreamStation: number | null; downstreamStation: number | null }[] = []

  for (let i = 0; i < nums.length; i += 2) {
    if (i + 1 < nums.length) {
      stationPairs.push({
        upstreamStation: nums[i],
        downstreamStation: nums[i + 1],
      })
    }
  }

  return stationPairs
}
